import { render, staticRenderFns } from "./ConveyorTable.vue?vue&type=template&id=638598a4&"
import script from "./ConveyorTable.vue?vue&type=script&lang=js&"
export * from "./ConveyorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports